import { ImmutableObject } from "@hookstate/core"
import { Typography } from "@mui/material"
import Stack from "@mui/material/Stack"
import { FC } from "react"

import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"
import { Account, useAccount } from "src/states/account"
import { SharedPageProps } from "src/types/SharedPageProps"

import styles from "./AccountProfile.module.scss"
import { CompanyData } from "./CompanyData"
import { Contacts } from "./Contacts"
import { PersonalData } from "./PersonalData"

const bem = create(styles, "AccountProfile")

interface AccountProfileProps extends SharedPageProps {
  account: ImmutableObject<Account>
}

export const AccountProfile: FC<AccountProfileProps> = () => {
  const { messages: translations } = useTranslation()
  const profileTranslations = translations.pages.account.overview.profile
  const account = useAccount()
  const hasName = account.firstName && account.lastName
  return (
    <Stack className={bem("content")} direction={"column"} spacing={3.5}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography className={bem("label__wellcome")} variant={"h1"}>
          {profileTranslations.welcome}
          {hasName ? `, ${account.firstName} ${account.lastName}` : ""}!
        </Typography>
      </Stack>
      <PersonalData />
      <Contacts />
      {/* <Adresses />
      <CoOrderers /> */}
      <CompanyData />
    </Stack>
  )
}
